import React from 'react';
import { TrophyIcon, UsersIcon, ArrowRightIcon, StarIcon } from 'lucide-react';
export function PolicePistolCombat() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#f8f6f0'
  }} aria-label="Police Pistol Combat" data-id="element-406">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-407">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start" data-id="element-408">
          {/* Content */}
          <div className="flex-1" data-id="element-409">
            <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-410">
              Competitive Shooting
            </p>
            <h2 className="text-3xl md:text-4xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-411">
              Police Pistol Combat
            </h2>
            <div className="section-divider" data-id="element-412" />

            <p className="text-base leading-relaxed mb-4" style={{
            color: '#3a3a3a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-413">
              Originally developed as training for law enforcement, Police
              Pistol Combat (PPC) has evolved into a thrilling competitive
              shooting sport. Shooters engage targets from multiple positions
              and distances, all within strict time limits — keeping skills
              sharp and competition fierce.
            </p>
            <p className="text-base leading-relaxed mb-8" style={{
            color: '#3a3a3a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-414">
              FLSC hosts both Fall and Winter indoor PPC leagues, plus an annual
              competition that draws shooters from across the region — including
              competitors from Canada. Prizes range from pistols to rifles and
              more.
              <strong style={{
              color: '#1e3d2f'
            }} data-id="element-415">
                {' '}
                Membership is not required
              </strong>{' '}
              — PPC league participation is open to the public.
            </p>

            <a href="/19.html" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
            backgroundColor: '#1e3d2f',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-416">
              Click Here for More Details
              <ArrowRightIcon size={15} data-id="element-417" />
            </a>
          </div>

          {/* Highlight cards */}
          <div className="w-full lg:w-80 flex-shrink-0 space-y-4" data-id="element-418">
            <div className="rounded-2xl p-6" style={{
            backgroundColor: '#1e3d2f'
          }} data-id="element-419">
              <TrophyIcon size={28} className="mb-3" style={{
              color: '#c8a84b'
            }} data-id="element-420" />
              <h3 className="text-lg font-bold uppercase mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-421">
                Annual Competition
              </h3>
              <p className="text-sm" style={{
              color: '#a0b8a8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-422">
                Draws shooters from across Michigan and Canada. Prizes include
                pistols, rifles, and more.
              </p>
            </div>

            <div className="rounded-2xl p-6" style={{
            backgroundColor: '#ffffff',
            border: '1px solid #ede9e0'
          }} data-id="element-423">
              <UsersIcon size={28} className="mb-3" style={{
              color: '#2d5a3d'
            }} data-id="element-424" />
              <h3 className="text-lg font-bold uppercase mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-425">
                Open to the Public
              </h3>
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-426">
                No membership required. Fall and Winter leagues available. New
                shooters welcome.
              </p>
            </div>

            <div className="rounded-2xl p-6" style={{
            backgroundColor: '#ffffff',
            border: '1px solid #ede9e0'
          }} data-id="element-427">
              <StarIcon size={28} className="mb-3" style={{
              color: '#2d5a3d'
            }} data-id="element-428" />
              <h3 className="text-lg font-bold uppercase mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-429">
                Leagues
              </h3>
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-430">
                Sunday mornings &amp; Monday evenings. Begins September, runs
                ~14 weeks through early April.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}